import log from 'loglevel';

log.setDefaultLevel('TRACE');
export { log as logger };
